"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = exports.MessageContainer = exports.Message = exports.MainContainer = exports.Icon = exports.Header = exports.FirstButton = exports.Detail = exports.ContainerButtons = exports.Close = exports.Button = exports.BoldText = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

var MainContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  background: #281f3366;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));

exports.MainContainer = MainContainer;

var Header = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n"])));

exports.Header = Header;

var MessageContainer = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  padding: 40px 20px;\n  box-sizing: border-box;\n  width: 600px;\n  min-height: ", ";\n  background: #281f33;\n  border-radius: 39px;\n  & > .generic-text {\n    width: 100%;\n    font-family: Raleway;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    text-align: center;\n    color: #f7f7f7;\n    margin: 20px 0px;\n  }\n"])), function (props) {
  return props.height ? "300px" : "190px";
});

exports.MessageContainer = MessageContainer;

var TextArea = _styledComponents.default.textarea(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  width: 479px;\n  height: 84px;\n  background: #f0eef2;\n  border-radius: 4px;\n  color: #817393;\n  margin-bottom: 10px;\n"])));

exports.TextArea = TextArea;

var Close = _styledComponents.default.figure(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  cursor: pointer;\n  right: 45px;\n  > img {\n    width: 14px;\n    height: 14px;\n  }\n"])));

exports.Close = Close;

var Icon = _styledComponents.default.figure(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 10px;\n  height: ", ";\n  > img {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (props) {
  return props.heightImg && props.heightImg;
}, function (props) {
  return props.widthImg ? props.widthImg : "85px";
}, function (props) {
  return props.heightImg ? props.heightImg : "85px";
});

exports.Icon = Icon;

var BoldText = _styledComponents.default.span(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 600;\n"])));

exports.BoldText = BoldText;

var Message = _styledComponents.default.p(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  font-family: Raleway;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 24px;\n  text-align: center;\n  color: #f7f7f7;\n  margin: 20px 0px;\n"])));

exports.Message = Message;

var ContainerButtons = _styledComponents.default.div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: space-around;\n"])));

exports.ContainerButtons = ContainerButtons;

var FirstButton = _styledComponents.default.p(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 0 40px;\n  border: 1px solid #f0eef2;\n  box-sizing: border-box;\n  border-radius: 30px;\n  font-family: Avenir Next;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  color: #f0eef2;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  cursor: pointer;\n"])));

exports.FirstButton = FirstButton;
var Button = (0, _styledComponents.default)(FirstButton)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  border: 0;\n  background: #e33aa9;\n  cursor: pointer;\n"])));
exports.Button = Button;
var Detail = (0, _styledComponents.default)(Message)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: bold;\n  font-size: 18px;\n  white-space: normal;\n"])));
exports.Detail = Detail;